import { MatDialogRef } from '@angular/material/dialog';
import { SecurityQuestionModel, SecurityQuestionSearchCriteria } from '../../../../../models';
import { SecurityCheckContextType } from '../../../../../constants';
import { SecurityCheckTypeEnum, SecurityQuestionGroupEnum } from '../../../../../../store';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

export class SecurityQuestionLoad {
  public static readonly type = '[SecurityCheck] Get Questions';

  constructor(
    public payload: {
      id: number;
      searchCriteria: SecurityQuestionSearchCriteria;
    },
  ) {}
}

export class SecurityQuestionSetType {
  public static readonly type = '[SecurityCheck] Set Type';

  constructor(public payload: SecurityCheckContextType) {}
}

export class SecurityQuestionSetId {
  public static readonly type = '[SecurityCheck] Set Id';

  constructor(public payload: number) {}
}

export class SecurityQuestionAdd {
  public static readonly type = '[SecurityCheck] Add New Question';

  constructor(
    public payload: {
      id: number;
      question: SecurityQuestionModel;
      dialog: MatDialogRef<unknown>;
    },
  ) {}
}

export class SecurityQuestionUpdate {
  public static readonly type = '[SecurityCheck] Update Question';

  constructor(
    public payload: {
      question: SecurityQuestionModel;
      dialog: MatDialogRef<unknown>;
    },
  ) {}
}

export class SecurityQuestionDelete {
  public static readonly type = '[SecurityCheck] Delete Question';

  constructor(
    public payload: {
      questionId: number;
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      type: SecurityCheckTypeEnum;
      group: SecurityQuestionGroupEnum;
    },
  ) {}
}

export class SecurityQuestionSavePositions {
  public static readonly type = '[SecurityCheck] Save Positions';

  constructor(public questions: SecurityQuestionModel[]) {}
}

export class SecurityQuestionsInitialState {
  public static readonly type = '[SecurityCheck] Set Initial State';
}
